import { render, staticRenderFns } from "./UnreadMessagesCard.vue?vue&type=template&id=01fe6ab2&scoped=true&"
import script from "./UnreadMessagesCard.vue?vue&type=script&lang=ts&"
export * from "./UnreadMessagesCard.vue?vue&type=script&lang=ts&"
import style0 from "./UnreadMessagesCard.vue?vue&type=style&index=0&id=01fe6ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe6ab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
